import React, { useState } from 'react';
import axios from 'axios';
import StatusModal from '../StatusModal/StatusModal';
import './EditStatusButton.css';

const EditStatusButton = ({ dni, currentStatus, onStatusUpdate, paciente }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Use the same base URL as in Home.js
  const api = axios.create({
    baseURL: '/api',   
    timeout: 10000,
  });

  const handleSave = async (dni, newStatus, fechaSeleccionada) => {
    const requestData = {
      dni: String(dni).trim(),  
      estado: newStatus,
      fechaSeleccionada: fechaSeleccionada || "" // Always include fechaSeleccionada, empty string if not provided
    };
    

    
    try {
      const response = await api.put('/paciente/estado', requestData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      

      
      if (response.status < 200 || response.status >= 300) {
        const errorMessage = response.data?.detail || 
                           response.data?.message || 
                           response.data?.error || 
                           `HTTP error! status: ${response.status}`;
        const error = new Error(errorMessage);
        error.status = response.status;
        error.response = response.data;
        throw error;
      }
  
      // Call the parent component's update function with the date
      onStatusUpdate(dni, newStatus, fechaSeleccionada);
      return response.data;
      
    } catch (error) {
      console.error('Error in handleSave:', {
        name: error.name,
        message: error.message,
        status: error.status,
        stack: error.stack,
        response: error.response,
        requestData: requestData
      });
      
      if (error.name === 'AbortError') {
        throw new Error('La solicitud tardó demasiado tiempo. Por favor, verifica tu conexión.');
      }
      
      throw error; // Re-throw to be handled by the modal
    }
  };

  return (
    <>
      <button 
        className="edit-status-button"
        onClick={() => setIsModalOpen(true)}
        title="Editar estado"
      >
        Editar
      </button>
      
      <StatusModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSave}
        currentStatus={currentStatus}
        dni={dni}
        selectedItem={paciente}
      />
    </>
  );
};

export default EditStatusButton;
